import cn from 'classnames'
import dynamic from 'next/dynamic'
import React, { memo, useEffect } from 'react'
import { FOUNDERS_EXECUTIVE_TEAM } from 'src/constants/constants'
import { ICompany } from 'src/graphql/generated/hooks'
import { SectionItem } from 'src/types'
import { checkNotEmpty } from 'src/utils/checkNotEmpty'

import SkeletonLoading from '../SkeletonLoading/SkeletonLoading'
import { SolutionFounderItem } from '../SolutionFounderItem/SolutionFounderItem'

export interface VendorDetailContainerProps {
  className?: string
  company: ICompany
  isFromCompany?: boolean
}

const Section = dynamic(() => import('src/components/global/Overview/Section').then((mod) => mod.Section), {
  loading: () => <SkeletonLoading className="bg-navy" />,
})

/**
 * Primary UI component for user interaction
 */
export const CompanyDetailContainer: React.FC<VendorDetailContainerProps> = memo(
  ({ className, company, isFromCompany = false }) => {
    const founders = company?.founders || []
    const isDiverseLeadership = company?.isDiverseLeadership || false
    const randomNum = Math.floor(Math.random() * 1000)
    const [detailsItems, setDetailsItems] = React.useState<SectionItem[]>([])

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [companyData, setCompanyData] = React.useState<ICompany>(company)

    useEffect(() => {
      const _detailsItems: SectionItem[] = []
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if (checkNotEmpty(founders) && !detailsItems.some((item: any) => item.title === FOUNDERS_EXECUTIVE_TEAM)) {
        const foundersItem: SectionItem = {
          title: FOUNDERS_EXECUTIVE_TEAM, // 'Founders/Executive Team',
          type: 'CustomList',
          subType: '',
          isFullWidth: true,
          items: founders || [],
          isDiverseLeadership: isDiverseLeadership,
        }
        _detailsItems.push(foundersItem)
      }
      if (_detailsItems.length > 0) {
        if (detailsItems.length > 0) {
          setDetailsItems(detailsItems.concat(_detailsItems))
        } else {
          setDetailsItems(_detailsItems)
        }
      }
    }, [company])

    return (
      <div className={cn(className, 'flex flex-col justify-center w-full')}>
        {detailsItems?.length > 0 && (
          <div className="flex flex-col justify-center w-full">
            <div className="!max-w-[1100px] w-full flex md:flex-row flex-col py-2">
              <div className={`flex flex-col w-full`}>
                {detailsItems.length > 0 && (
                  <Section
                    key={randomNum + '-Overview-Details'}
                    title={'Details'}
                    description={''}
                    url={''}
                    items={detailsItems}
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    renderItem={(founder: any) => <SolutionFounderItem founder={founder} />}
                    isFromCompany={isFromCompany}
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    )
  },
)
